__turbopack_context__.v({
  "button": "ButtonLink-module__uSMsYW__button",
});
